import { render, staticRenderFns } from "./fileMaxSize-editor.vue?vue&type=template&id=6b0c87ee&scoped=true"
import script from "./fileMaxSize-editor.vue?vue&type=script&lang=js"
export * from "./fileMaxSize-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c87ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0c87ee')) {
      api.createRecord('6b0c87ee', component.options)
    } else {
      api.reload('6b0c87ee', component.options)
    }
    module.hot.accept("./fileMaxSize-editor.vue?vue&type=template&id=6b0c87ee&scoped=true", function () {
      api.rerender('6b0c87ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/fileMaxSize-editor.vue"
export default component.exports